/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {dismissSuggestedAction} from '../api'

export const useMutationDismissSuggestedAction = createReactQueryMutationHook('dismissSuggestedAction', dismissSuggestedAction)
